import React, { useState, useEffect } from 'react'

import {
  Avatar,
} from "@material-tailwind/react";

import { useShared } from '../../hooks/useShared'
import AMenu from '../../components/partials/AMenu';
import MainSection from '../../components/sections/MainSection';

const TABLE_HEAD = ["#", 'لوگو', "اسم شرکت", 'نوع فعاليت', 'تعرفه', "اينوايس", "مکتوب", "تماس", 'تاريخ ايجاد رکورد', 'اقدامات'];

const menuData = [
  { flag: "View", name: 'جزئیات', icon: 'eye-outline', roles: [1, 2, 23] },
  { flag: "Edit", name: 'ويرايش', icon: 'create-outline', roles: [1, 2, 23] },
  { flag: "Delete", name: 'حذف', icon: 'trash-outline', roles: [1, 2] },
]

const searchInputFields = [
  { label: 'نام', name: 'name', type: 'text', roles: [1], icon: 'business-outline', className: 'md:col-span-2' },
  { label: 'شماره جواز', name: 'license_number', type: 'text', roles: [1], icon: 'checkmark-outline', className: 'md:col-span-2', },
  { label: 'TIN شماره ', name: 'tin_number', type: 'text', roles: [1], icon: 'checkmark-outline', className: 'md:col-span-2' },
  { label: 'ادرس', name: 'address', type: 'text', roles: [1], icon: 'location-outline', className: 'md:col-span-2' },
  { label: 'مالک', name: 'owner', type: 'select', roles: [1], icon: null, className: 'md:col-span-2', options: [] },
  { label: 'اضافه کننده', name: 'creator_id', type: 'select', roles: [1], icon: 'text-outline', className: 'md:col-span-2', options: [] },
  { label: 'تاريح ايجاد', name: 'created_at', type: 'pdate', roles: [1], icon: 'text-outline', className: 'md:col-span-2', },
];



const csvHeaders = [
  { label: "#", key: "index" },
  { label: "نام", key: "name_af" },
  { label: "نام انگسی", key: "name_en" },
  { label: "شماره جواز", key: "license_number" },
  { label: "TIN شماره", key: "tin_number" },
  { label: "تاريخ تائسيس", key: "establishment_date" },
  { label: "ادرس", key: "address" },
  { label: "مالک", key: "owner" },
  { label: "تاريخ", key: "date" },
  { label: "حالت", key: "status" },
  { label: "اضافه کننده", key: "creator_id" },
];

const breadcrumbs = [{ name: 'شرکت ها', link: '/companies' }]

export default function Companies() {

  const { com, consts, auth, setModel, models, navigate, setShowViewDialog, showDeleteDialog, setShowDeleteDialog } = useShared();

  useEffect(() => {
    if (!auth.hasRole([1, 2, 4, 23])) {
      return navigate("/db/notAllowed")
    }
  }, [])



  const handleMenu = (model, flag = false) => {
    console.log("handleMenu ", model, flag);


    if (flag === 'delete') {
      setModel(model)
      setShowDeleteDialog(!showDeleteDialog)

    }
    if (flag === 'edit') {
      setModel(model)
      // setShowNewModelDialog(true)
      navigate(`/db/companies/new_company/${model?.id}`, { state: {} })
    }
    if (flag === 'view') {
      setModel(model)
      setShowViewDialog(true)
    }
  };

  const gotoPage = (cId, which="tariffs") => {
    navigate(`/db/${which}/0`, { state: { company_id: cId } })
  }

  const handleViewDialog = (obj) => {
    return [
      { l: 'نام', v: obj?.name_af },
      { l: 'نام انگلسی', v: obj?.name_en },
      { l: 'شماره جواز', v: obj?.license_number },
      { l: 'TIN شماره', v: obj?.tin_number },
      { l: 'مالک', v: obj?.owner?.full_name },
      { l: 'تاريخ تائسيس', v: obj?.establishment_date },
      { l: 'ادرس', v: obj?.address },
      { l: 'اضافه کننده', v: obj?.user?.full_name },
      { l: 'حالت', v: obj?.status },
      { l: 'تاريخ', v: com.ddmmyyhhmmA(obj?.updated_at) },
      { l: 'لوگو', v: obj?.image_data ? consts.BASE_URL + obj?.image_data?.path : consts.DEFULAT_USER_PHOTO },
    ]
  }

  const getTableData = () => {
    return (<tbody className=''>
      {models?.data?.map((r, i) => {

        return (<tr key={r.id} >
          <td >{models?.from + i}</td>
          <td className='min-w-[50px] md:min-w-[80px]'>{<Avatar variant="rounded" withBorder={true} color="teal" src={r?.image_data ? consts.BASE_URL + r.image_data?.path : consts.DEFULAT_USER_PHOTO} alt={r.first_name} className="h-8 w-8 md:h-12 md:w-12 p-0.5" />}</td>
          <th className='!p-1'>
            <div className='flex flex-row items-center'>
              <div className={` rounded-full h-[10px] w-[10px] ${r.status === 1 ? 'bg-green-500' : 'bg-red-700'}`} />
              <div className='ml-2'>
                <p>{r.name_af}</p>
                <p>{r.name_en}</p>
              </div>
            </div>
          </th>
          <td >{r?.company_type?.label}</td>
          <td className='text-center'> {r?.tariffs_count>0 && <span className=' cursor-pointer text-blue-600' onClick={() => gotoPage(r?.id)}>({r?.tariffs_count}) </span> } </td>
          <td className='text-center'>{r?.invoices_count>0&& <span className=' cursor-pointer text-green-600' onClick={() => gotoPage(r?.id, "invoices")}>({r?.invoices_count})</span>} </td>
          <td className='text-center'>{ r?.letters_count>0&&<span className=' cursor-pointer text-purple-600' onClick={() => gotoPage(r?.id, "export_duty_letters")}>({r?.letters_count})</span>} </td>
          <td>
            <p>{r?.owner?.full_name}</p>
            <p>{r?.phone? r?.phone: r?.owner?.phone}</p>
            <p>{r?.email? r?.email: r?.owner?.email}</p>
          </td>

          <td style={{ direction: 'ltr' }}>{com.dateConvert(r?.created_at, false, true)}
            <p>{r?.user?.full_name}</p>
          </td>
          <td >
            <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), row: r, menuData }} />

          </td>
        </tr>)
      })
      }
    </tbody>)
  }

  return (
    <MainSection v={{
      handleViewDialog,
      newModelInputFields: [{ test: "new page" }],
      searchInputFields,
      TABLE_HEAD,
      breadcrumbs,
      tableData: getTableData(),
      addNewItemTitle: "شرکت جديد",
      tableTitle: 'لست شرکت‌ها',
      url: "companies",
      mUrl: { delete: 'companies', create: 'companies', getAll: 'companyAdvanceSearch' },
      modelName: { name: 'companies', af: 'اينوايس', dbTable: 'Company' },
      advanceSearch: 'companyAdvanceSearch',
      modelScreen: 'Companies',
      newModelDialogClassName: "h-[90%]",
      csv: { csvHeaders, show: true }
    }} />
  )
}


